import { z } from 'zod';

export const isDateWithin60Days = (value: string | Date | null | undefined): boolean => {
	if (!value) return false;
	const date = value instanceof Date ? value : new Date(value);
	if (isNaN(date.getTime())) return false;
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const diffDays = Math.round((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
	return diffDays >= -60 && diffDays <= 60;
};

export const dateWithin60DaysSchema = z.union([z.string(), z.date()]).refine(
	(v) => isDateWithin60Days(v),
	{ message: 'Date must be within 60 days in the past or future' }
);

export const optionalDateWithin60DaysSchema = z
	.union([z.string(), z.date(), z.null(), z.undefined()])
	.optional()
	.refine(
		(v) => v === null || v === undefined || v === '' || isDateWithin60Days(v as string | Date),
		{ message: 'Date must be within 60 days in the past or future' }
	);
